import {BlockComponentProps} from 'client-react-block-renderer';
import React, {Component} from 'react';
import {SearchResultsController} from 'search-rat';

export default class BlockSiteSearchResults
extends Component<BlockComponentProps> {
    public render() {
        const instanceConfig = this.props.config as any;
        return (<SearchResultsController {...instanceConfig} />);
    }
}
